<template>
  <div>
    <div class="c_top_title">{{$t('beth_text.renew')}}</div>

    <div class="t_h1">
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top">
          <el-form-item>
            <el-input v-model="form.card_username" :placeholder="$t('bank_card.Username')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.card_email" :placeholder="$t('main.text185')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker :editable="false" popper-class="time_box" :clearable="false" v-model="time" type="daterange"
              :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'" value-format="yyyy-MM-dd" range-separator="-"
              :start-placeholder="$t('main.text324')" :end-placeholder="$t('main.text325')">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="project_name=='VisionLife'">
            <el-input v-model="form.visionLife_id" :placeholder="$t('bank_card.Client_Ref_ID')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.card_level" :placeholder="$t('bank_card.card_level')">
              <el-option v-for="(item,index) in cardLevelArray" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 付款状态 0免费 1支付 2待付 3逾期 4未付(取消) 5即将到期 默认6所有 -->
            <el-select v-model="form.payment_status" :placeholder="$t('beth_text.Renewal_Status')">
              <el-option :label="$t('beth_text.free_charge')" :value="0"></el-option>
              <el-option :label="$t('beth_text.Pending_status')" :value="2"></el-option>
              <el-option :label="$t('beth_text.pay1')" :value="1"></el-option>
              <el-option :label="$t('beth_text.due_soon')" :value="5"></el-option>
              <el-option :label="$t('beth_text.overdue')" :value="3"></el-option>
              <el-option :label="$t('beth_text.Discontinued')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 1自动 2确认自动 3停止 4用户 默认0所有 -->
            <el-select v-model="form.deduction_mode" :placeholder="$t('beth_text.Deduction_Mode')">
              <el-option :label="$t('beth_text.auto')" :value="1"></el-option>
              <el-option :label="$t('beth_text.automatically')" :value="2"></el-option>
              <el-option :label="$t('beth_text.stop')" :value="3"></el-option>
              <el-option :label="$t('beth_text.User')" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{$t('main.text329')}}</el-button>
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{$t('main.text330')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="transaction_h">
      <div class="contract_m_top">
        <div class="c_top_title"></div>
      </div>

      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">{{$t('bank_card.There')}} {{total}} {{$t('bank_card.are_records')}}</div>
          </div>
          <div>
            <el-button class="export_btn border_set_color2" size="medium" v-if="authjson.authjson(['13-1'])" @click="download_btn">
              {{$t('main.text333')}}
            </el-button>
            <el-button class="export_btn border_set_color2" size="medium" v-if="authjson.authjson(['13-5'])" @click="modify_mode_all">
              {{$t('beth_text.Modify_Mode')}}
            </el-button>
            
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%" @selection-change="handleSelectionChange">

            <el-table-column
              label="#"
              type="index"
              width="60">
            </el-table-column>

            <el-table-column :label="$t('bank_card.Username')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_username||"-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text185')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_email||"-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text665')" min-width="120">
              <span slot-scope="props">
                <!-- method_type  1首发卡 2续卡 3补卡 -->
                <span v-if="props.row.method_type==1">{{ $t('new3_txt.IniCard') }}</span>
                <span v-else-if="props.row.method_type==2">{{ $t('new3_txt.RepNat') }}</span>
                <span v-else-if="props.row.method_type==3">{{ $t('new3_txt.RepExc') }}</span>
                <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Client_Ref_ID')" min-width="120" v-if="project_name=='VisionLife'">
              <span slot-scope="props">
                {{ props.row.visionLife_id}}
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.card_level')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_level_name||"-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Card_No')" min-width="120">
                <span slot-scope="props">
                  {{ props.row.card_number||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Expiry_Date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.expire_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.yearly_expire_date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.yearly_expire_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Term_Start_Date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.term_start_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Term_End_Date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.term_end_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Auto_Renewal_Date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.payment_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Payment_Months')" min-width="120">
                <span slot-scope="props">
                  {{ props.row.payment_month }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Membership_Fee_Due')+'(USDC/T)'" min-width="120">
                <span slot-scope="props">
                  {{ props.row.payment_amount||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Renewal_Status')" min-width="120">
                <span slot-scope="props">
                  <!-- "payment_status": 1, //付款状态 0免费 1支付 2待付 3逾期 4未付(取消) 5即将到期 接口返回“-” 直接显示 -->
                  <span v-if="props.row.payment_status==0">{{$t('beth_text.free_charge')}}</span>
                  <span v-else-if="props.row.payment_status==1">{{$t('beth_text.pay1')}}</span>
                  <span v-else-if="props.row.payment_status==2">{{$t('beth_text.Pending_status')}}</span>
                  <span v-else-if="props.row.payment_status==3">{{$t('beth_text.overdue')}}</span>
                  <span v-else-if="props.row.payment_status==4">{{$t('beth_text.Discontinued')}}</span>
                  <span v-else-if="props.row.payment_status==5">{{$t('beth_text.due_soon')}}</span>
                  <span v-else>{{props.row.payment_status}}</span>
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Payment_Date')" min-width="120">
                <span slot-scope="props">
                    {{ props.row.actually_payment_date||"-" }}
                </span>
            </el-table-column>

            <el-table-column :label="$t('beth_text.Deduction_Mode')" min-width="120">
                <span slot-scope="props">
                  <!-- "deduction_mode": 1, //1自动 2确认自动 3停止 4用户 -->
                  <span v-if="props.row.deduction_mode==1">{{$t('beth_text.auto')}}</span>
                  <span v-else-if="props.row.deduction_mode==2">{{$t('beth_text.automatically')}}</span>
                  <span v-else-if="props.row.deduction_mode==3">{{$t('beth_text.stop')}}</span>
                  <span v-else-if="props.row.deduction_mode==4">{{$t('beth_text.User')}}</span>
                  <span v-else>-</span>
                </span>
            </el-table-column>

            <el-table-column :label="$t('new1_txt.card_status')" min-width="120">
              <span slot-scope="props">
                <span v-if="props.row.card_status==1">{{$t('new1_txt.Inactive')}}</span>
                <span v-else-if="props.row.card_status==2">{{$t('bank_card.active')}}</span>
                <span v-else-if="props.row.card_status==3">{{$t('bank_card.blocked')}}</span>
                <span v-else-if="props.row.card_status==4">{{$t('bank_card.Cancelled')}}</span>
                <span v-else-if="props.row.card_status==5">{{$t('beth_text.Expired')}}</span>
                <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text568')" min-width="120">
                <span slot-scope="props">
                  <span>{{props.row.card_balance}}</span>
                  <i class="el-icon-refresh refresh_btn" @click="refresh_btn(props.row)"></i>
                </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Remarks')" min-width="120">
                <span slot-scope="props">
                  <span>{{props.row.deduction_mode_remark}}</span>
                </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.operate')"  min-width="160">
                <span slot-scope="props">
                  <div class="view_box" v-if="authjson.authjson(['13-2'])" @click="edit_remarks(props.row)">{{$t('beth_text.Edit_Remarks')}}</div>
                  <div class="view_box" v-if="authjson.authjson(['13-3'])" @click="modify_mode(props.row)">{{$t('beth_text.Deduction_Mode')}}</div>
                  <div class="view_box" v-if="authjson.authjson(['13-4'])" @click="view_btn(props.row)">{{$t('bank_card.View')}}</div>
                </span>
            </el-table-column>

            <el-table-column v-if="authjson.authjson(['13-5'])"
              type="selection"
              width="55">
            </el-table-column>

          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑备注 弹框 -->
    <el-dialog
      :title="$t('beth_text.Edit_Remarks')"
      :visible.sync="edit_remarks_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('bank_card.Remarks')">
              <el-input v-model="edit_r.content"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_remarks_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="edit_remarks_dlg_confirm" class="confirm_btn">
            {{$t('main.text130')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改模式 弹框 -->
    <el-dialog
      :title="$t('beth_text.Deduction_Mode')"
      :visible.sync="modify_mode_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('beth_text.Deduction_Mode')">
              <el-select v-model="modify_m.deduction_mode" placeholder=" ">
                <el-option :label="$t('beth_text.auto')" :value="1"></el-option>
                <el-option :label="$t('beth_text.automatically')" :value="2"></el-option>
                <el-option :label="$t('beth_text.stop')" :value="3"></el-option>
                <el-option :label="$t('beth_text.User')" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modify_mode_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="modify_mode_dlg_confirm" class="confirm_btn">
            {{$t('main.text130')}}
        </el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
import { annualFee_record,annualFee_remark,annualFee_modify,annualFee_download,refresh} from "@/api/api";

export default {
  data() {
    return {
      currentPage: 1,
      page: 0, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      tableData: [],
      cardLevelArray:[],
      time:"",
      form:{
        card_email:'',
        card_username:"",
        visionLife_id:"",
        card_level:"",
        payment_status:"",//0免费 1支付 2待付 3逾期 4未付(取消) 5即将到期 默认6所有
        deduction_mode:"",//1自动 2确认自动 3停止 4用户 默认0所有
      },
      edit_remarks_dlg:false,
      edit_r:{
        content:"",
      },
      api_card_id:"",
      card_ids:[],
      modify_mode_dlg:false,
      modify_m:{
        deduction_mode:"",
      },
      project_name:sessionStorage.getItem("project_name"),

    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", ' ');
    this.get_list();
  },
  methods: {
    async get_list() {
      const res = await annualFee_record({
        page:this.page,
        limit:this.limit,
        card_level:this.form.card_level,
        start_date:this.time[0] || '',
        end_date:this.time[1] || '',
        card_email:this.form.card_email,
        card_username:this.form.card_username,
        visionLife_id:this.form.visionLife_id,
        payment_status:this.form.payment_status!==''?this.form.payment_status:6,
        deduction_mode:this.form.deduction_mode!==''?this.form.deduction_mode:0,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.total = res.data.data.count;
      this.cardLevelArray = res.data.data.cardLevelArray;
      this.tableData = res.data.data.list;
      this.card_ids=[];

    },
    current_change(v){
      this.page=v - 1;
      this.limit=10;
      this.get_list();
    },
    reset_btn(){
      this.form={
        card_email:'',
        card_username:"",
        visionLife_id:"",
        card_level:"",
        payment_status:"",
        deduction_mode:"",
      },
      this.time="";
      this.page=0;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    apply_btn(){
      this.page=0;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },

    view_btn(row){
      this.$router.push({path:'/renew_info',query:{card_id:row.card_id}});
    },
    edit_remarks(row){
      this.api_card_id = row.card_id;
      this.edit_r.content=row.deduction_mode_remark=='-'?'':row.deduction_mode_remark;
      this.edit_remarks_dlg=true;
    },
    async edit_remarks_dlg_confirm(){
      if(!this.edit_r.content){
        return this.message.ismessage('error',this.$t('bank_card.Remarks'));
      }
      const res = await annualFee_remark({
        card_id	:this.api_card_id,
        remark:this.edit_r.content,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.message.ismessage('success',this.$t('main.text215'));
      this.edit_remarks_dlg=false;
      this.get_list();
    },
    modify_mode(row){
      this.card_ids=[];
      this.card_ids.push(row.card_id);
      this.modify_m.deduction_mode = row.deduction_mode;
      this.modify_mode_dlg=true;
    },
    modify_mode_all(){
      if(this.card_ids.length){
        this.modify_m.deduction_mode='';
        this.modify_mode_dlg=true;
      }
    },
    async modify_mode_dlg_confirm(){
      // console.log(this.card_ids);
      if(this.card_ids.length){
        const res = await annualFee_modify({
          card_ids:this.card_ids,
          deduction_mode:this.modify_m.deduction_mode
        });
        if (res.data.code !== 200) {
          return this.message.ismessage('error',res.data.msg);
        }
        this.message.ismessage('success',this.$t('main.text215'));
        this.modify_mode_dlg=false;
        this.get_list();
      }
    },
    handleSelectionChange(arr){
      this.card_ids=[];
      for (const item of arr) {
        this.card_ids.push(item.card_id)
      }
    },

    download_btn() {
      if (this.total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      annualFee_download({
        card_level:this.form.card_level,
        start_date:this.time[0] || '',
        end_date:this.time[1] || '',
        card_email:this.form.card_email,
        card_username:this.form.card_username,
        visionLife_id:this.form.visionLife_id,
        payment_status:this.form.payment_status!==''?this.form.payment_status:6,
        deduction_mode:this.form.deduction_mode!==''?this.form.deduction_mode:0,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    async refresh_btn(row) {
      const res = await refresh({
        card_id:row.card_id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.get_list();
    },


  },

};
</script>

<style scoped>
.t_h1_top{
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box{
  background: #314B69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item{
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select{
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child{
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner{
  background: #223C58;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 100%;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus{
  min-width: 120px;
  border-color: #F1C788;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182A;
  margin-left: 20px;
}
.zdy_form .btn_box{
  width: auto;
}
.t_h2_box{
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
}
.t_h2_txt2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width{
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red{
  color: #F35F65;
}
.zdy_tab_header >>> .el-table tr th:last-child, .zdy_tab_header >>> .el-table__body tr td:last-child{
  padding-left: 0 !important;
}
.btn_icon{
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1{
  height: 32px;
  border: 1px solid #DEB981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #DEB981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2{
  height: 32px;
  border: 1px solid #FF4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FF4646;
  background: transparent;
  margin-top: 10px;
}
.top_text{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223C58;
  border-color: #223C58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active{
  background: #F35F65;
  border-color: #F35F65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1{
  display: flex;
  border-bottom: 1px solid #314B69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left{
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
}
.info_1_right{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text3{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.amount_box{
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223C58;
}
.top_text4{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  margin-bottom: 8px;
}
.top_text5{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text5_2:nth-child(8){
  padding-top: 10px;
}
.top_text5_2{
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner{
  /* width: 224px; */
  height: 68px;
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input{
  width: 100%;
}
.zdy_input{
  display: flex;
}
.zdy_form >>> .el-form-item__label{
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box{
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img{
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3{
  color: rgba(255, 255, 255, 0.8);
}
.bz_list{
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1{
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child{
  margin-bottom: 0;
}
.inp_btm_tit{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin{
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6{
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7{
  /* padding: 18px 12px 20px;
  background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
}
.div_num{
  flex: 1;
  background: #223C58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2{
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  min-width: 120px;
  text-align: center;
}
.top_text8{
  display: flex;
  margin-top: 12px;
}
.top_text8>div{
  width: 50%;
}
.top_text9{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text10{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
}
.warning_red{
  background: #FEDFE0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow{
  background: #E8DAC8;
}
.warning_red_icon i{
  color: #F35F65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #F35F65;
}
.warning_yellow_icon i,
.warning_yellow_text{
  color: #B28247;
}
.top_up_link{
  color: #041728;
  text-decoration: underline;
}
.yellow{
  color: #d9b680;
  cursor: pointer;
  margin-right: 10px;
}

.min_max_box{
  display:flex;
  justify-content: space-between;
}
.tup_checkbox,
.tup_checkbox >>> .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #fff;
  white-space: pre-wrap;
  display: flex;
}

</style>

<style>

.top_up_dlg{
  max-height: 95vh;
  overflow-y: auto;
}
.top_up_dlg::-webkit-scrollbar {
  width: 5px;
}
.top_up_dlg::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #F1C788;
}

.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell{
  background: #172C43 !important;
}
.cards_table .row_2_bgc:hover{
  background: #172C43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc ,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell{
  background: #172C43 !important;
}
/* ------ */
.bz_pop{
  color: #fff;
  font-size: 15px;
  background: #041E35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text{
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.c_top_title{
  font-size: 16px;
  margin-bottom: 20px;
}
.num_item{
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}
.num_item div{
  margin-bottom: 7px;
}
.num_item div:last-child{
  margin-bottom: 0;
}
.c_top_num_box .num_item{
  margin-right: 20px;
}
.c_top_num_box .num_item:last-child{
  margin-right: 0;
}
.el-input.is-disabled .el-input__inner {
  color: #000;
}
.bing_btn{
  cursor: pointer;
}
.select_btn{
  cursor: pointer;
  color: #11B8A6;
}
.binding_btn{
  cursor: pointer;
  color: #A2EF4D;
}
.next_info{
  cursor: pointer;
  color: #F1C788;
}
.card_body{
  max-height: 80vh;
  overflow-y: auto;
}
.icon_question{
  margin-left: 5px;
  cursor: pointer;
}
.block_value_box{
  text-align: center;
  margin: auto;
  margin-top: 30px;
  width: 75%;
}
.block_value_box .el-input__inner,
.block_value_box .el-range-input{
  background: #223C58;
  border: none;
  /* border-radius: 8px; */
  color: #fff;
  padding-left: 15px;
}
.dlg_inp_box{
  margin-top: 30px;
}
.block_value_box .el-select,
.time_width{
  width: 100% !important;
}
.card_foot{
  padding-bottom: 20px;
}
.warning_outline{
  cursor: pointer;
  margin-left: 5px;
}
.addr_txt{
  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  box-sizing: border-box;
  padding: 0 27px;
  color: #ffffff;
  opacity: 0.9;
  margin-top: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
.view_box{
  color: #409EFF;
  cursor: pointer;
}
.refresh_btn{
  cursor: pointer;
  margin-left: 7px;
  color: #DEB981;
  font-weight: 900;
}
</style>

<style>
.binding_dlg .d_body {
  max-width: 95% !important;
  margin: auto !important;
  padding-top: 0 !important;
}
/* @media screen and (max-height: 757px) {
  .card_dlg_position{
    top: 0 !important;
    transform: translate(-50%, 0) !important;
  }
} */
.card_foot .el-dialog__footer {
  padding-bottom: 30px;
}
.tooltip_w{
  max-width: 200px;
  word-wrap: break-word;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  .num_item{
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }

}
</style>
